/**
 * Converts a camelCase string to snake_case.
 */
function camelToSnake(str: string): string {
  return str
    .replace(/([A-Z][a-z]+)/g, (match) => `_${match.toLowerCase()}`)
    .replace(/([a-z])([A-Z])/g, (_, a, b) => `${a}_${b.toLowerCase()}`)
    .replace(/^_/, "");
}

function normalizeKeys(obj: unknown): unknown {
  if (Array.isArray(obj)) return obj.map(normalizeKeys);
  if (obj !== null && typeof obj === "object") {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        camelToSnake(key),
        normalizeKeys(value),
      ]),
    );
  }
  return obj;
}

/**
 * Recursively converts all object keys in extractedData from camelCase to snake_case.
 */
export function normalizeExtractedData(data: unknown): unknown {
  if (!data || typeof data !== "object") return data;
  return normalizeKeys(data);
}
